import {Room, SplitBooking} from '../../types/room'

/**
 * Takes list of rooms with offers and resets all room.hasClickedOffer and room.offers[].isClicked to false
 * @param rooms - List of rooms with offers to clear "clicked" flags from
 * @returns transformed rooms with offers which have "clicked" flags set to false
 */
export const clearIsClickedRoomOffers = (rooms: Room[]) =>
  rooms.map(room => ({
    ...room,
    hasClickedOffer: false,
    offers: room.offers.map(offer => ({...offer, isClicked: false}))
  }))

/**
 * Takes split booking object and resets isClicked flag to false
 * @param splitBooking - split booking object
 * @returns transformed split booking object wich isClicked flags set to false
 */
export const clearIsClickedSplitBooking = (splitBooking: SplitBooking) => ({
  ...splitBooking,
  isClicked: false
})
